import { CheckCircleFilled, ExperimentOutlined } from "@ant-design/icons";
import { Flex, Tag, Typography, theme } from "antd";
import { usePruebaContext } from "../../Hooks/Prueba/usepruebacontext";
import { listarRepsPrueba, pruebaTieneVariasReps } from "../../Util/pruebaReps";

const { useToken } = theme;

export default function SelectorRepPrueba() {
    const { token } = useToken();
    const { pruebas, repIndex, setRepIndex } = usePruebaContext();
    const prueba = pruebas[0];

    if (!pruebaTieneVariasReps(prueba)) return null;

    const opciones = listarRepsPrueba(prueba);

    return (
        <div style={{ width: "100%", paddingBottom: 20, boxSizing: "border-box" }}>
            <Flex
                vertical
                gap={14}
                style={{
                    width: "100%",
                    padding: "18px 32px",
                    borderRadius: 0,
                    background: `linear-gradient(145deg, ${token.colorBgElevated} 0%, rgba(250, 173, 20, 0.06) 100%)`,
                    borderTop: `1px solid ${token.colorBorderSecondary}`,
                    borderBottom: `1px solid ${token.colorBorderSecondary}`,
                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.35)",
                    boxSizing: "border-box",
                }}
            >
                <Flex align="center" justify="space-between" wrap="wrap" gap={8}>
                    <Flex align="center" gap={10}>
                        <span
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 36,
                                height: 36,
                                borderRadius: 10,
                                background: "rgba(250, 173, 20, 0.15)",
                                color: token.colorPrimary,
                                fontSize: 18,
                            }}
                        >
                            <ExperimentOutlined />
                        </span>
                        <div>
                            <Typography.Text strong style={{ display: "block", fontSize: 15 }}>
                                Repetición a visualizar
                            </Typography.Text>
                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                Elige qué intento quieres revisar en la gráfica
                            </Typography.Text>
                        </div>
                    </Flex>
                    <Tag
                        color="gold"
                        style={{
                            margin: 0,
                            fontWeight: 600,
                            borderRadius: 20,
                            padding: "2px 14px",
                            fontSize: 12,
                        }}
                    >
                        {opciones.length} repeticiones
                    </Tag>
                </Flex>

                <Flex
                    gap={12}
                    wrap="nowrap"
                    role="tablist"
                    aria-label="Repeticiones de la prueba"
                    style={{ width: "100%" }}
                >
                    {opciones.map((o) => {
                        const activa = repIndex === o.index;
                        return (
                            <button
                                key={o.key}
                                type="button"
                                role="tab"
                                aria-selected={activa}
                                onClick={() => setRepIndex(o.index)}
                                style={{
                                    flex: 1,
                                    minWidth: 0,
                                    cursor: "pointer",
                                    border: activa
                                        ? `2px solid ${token.colorPrimary}`
                                        : `1px solid ${token.colorBorder}`,
                                    borderRadius: 12,
                                    padding: "12px 16px",
                                    fontSize: 14,
                                    fontWeight: activa ? 600 : 500,
                                    fontFamily: "inherit",
                                    color: activa ? token.colorPrimary : token.colorText,
                                    background: activa
                                        ? "linear-gradient(180deg, rgba(250, 173, 20, 0.22) 0%, rgba(250, 173, 20, 0.08) 100%)"
                                        : token.colorBgContainer,
                                    boxShadow: activa
                                        ? "0 0 0 3px rgba(250, 173, 20, 0.12), 0 4px 14px rgba(0, 0, 0, 0.2)"
                                        : "none",
                                    transition: "all 0.2s ease",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 8,
                                }}
                                onMouseEnter={(e) => {
                                    if (!activa) {
                                        e.currentTarget.style.borderColor = token.colorPrimary;
                                        e.currentTarget.style.background = "rgba(250, 173, 20, 0.06)";
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!activa) {
                                        e.currentTarget.style.borderColor = token.colorBorder;
                                        e.currentTarget.style.background = token.colorBgContainer;
                                    }
                                }}
                            >
                                {activa ? (
                                    <CheckCircleFilled style={{ fontSize: 15, color: token.colorPrimary }} />
                                ) : (
                                    <span
                                        style={{
                                            width: 8,
                                            height: 8,
                                            borderRadius: "50%",
                                            background: token.colorTextQuaternary,
                                            flexShrink: 0,
                                        }}
                                    />
                                )}
                                {o.label}
                            </button>
                        );
                    })}
                </Flex>
            </Flex>
        </div>
    );
}
